/**
 * 用于存储账户信息
 */
import {SET_ACCOUNT, RETRIEVE_ACCOUNT} from '../mutation-types'

const state = {
  id: '-',
  name: '',
  username: '',
  email: '',
  openid: '',
  photo: ''
}

const mutations = {
  [SET_ACCOUNT] (state, account) {
    Object.keys(account).forEach((key) => {
      state[key] = account[key]
    })
    localStorage.setItem('home_account', JSON.stringify(account))
  },
  [RETRIEVE_ACCOUNT] (state) {
    let accountStr = localStorage.getItem('home_account')
    let hasAccount = !!accountStr
    let account = JSON.parse(accountStr)

    if (hasAccount) {
      Object.keys(account).forEach((key) => {
        state[key] = account[key]
      })
    }
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/account.js